import { useRef, type FC } from 'react';
import { HashRouter, Navigate, Route, Routes } from 'react-router';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { ThemeProvider } from '#apps/client-web/features/user-settings/providers/theme-provider';

import {
  AuditListPage,
  useAuditListPageViewModel,
} from '#apps/client-web/features/audit/pages/audit-list';
import { UserProfilePage } from '#apps/client-web/features/user-profile/pages';
import { UserSettingsPage } from '#apps/client-web/features/user-settings/pages';

import { AppLayout } from './components/app-layout';
import { AuthProvider } from './providers/auth';
import { RouteNotFoundPage } from './pages/route-not-found';
import { routes } from './routes';
import { store } from './store';

import './app.module.scss';

export const App: FC = () => {
  const queryClient = useRef(new QueryClient());

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient.current}>
        <AuthProvider>
          <ThemeProvider>
            <HashRouter>
              <Routes>
                <Route element={<AppLayout />}>
                  {/* Redirect / to /audits */}
                  <Route
                    index
                    element={<Navigate to={routes.audit.index} replace />}
                  />

                  <Route path={routes.audit.index}>
                    <Route
                      index
                      element={
                        <AuditListPage
                          useViewModel={useAuditListPageViewModel}
                        />
                      }
                    />

                    {/* <Route path={routes.audit.details} element={<} /> */}
                  </Route>

                  <Route
                    path={routes.userProfile.index}
                    element={<UserProfilePage />}
                  />

                  <Route
                    path={routes.userSettings.index}
                    element={<UserSettingsPage />}
                  />

                  {/* Catch all unmatched routes  */}
                  <Route path="*" element={<RouteNotFoundPage />} />
                </Route>
              </Routes>
            </HashRouter>
          </ThemeProvider>
        </AuthProvider>
      </QueryClientProvider>
    </Provider>
  );
};
